module.exports = __webpack_public_path__ + "static/media/bg_done.c7f9391b.png";